import { useI18nContext } from "@hopper-b2b/i18n";
import { getMaintenanceMessages } from "../../utilities/getMaintenanceMessages";
import { Maintenance } from "../Maintenance";

/**
 * MaintenanceRoute component that displays locale-aware maintenance messages.
 *
 * This route is primarily accessed when harness-level maintenance mode redirects
 * all traffic to /maintenance at the ingress level. The route always renders the
 * maintenance page when accessed, regardless of app-level maintenance state.
 *
 * This behavior is intentional:
 * - Harness-level redirects expect this route to show maintenance
 * - Users accessing /maintenance directly see the page (useful for testing)
 * - App-level pre-auth check (in App.tsx) prevents normal route access when enabled
 *
 * Uses locale-specific environment variables:
 * - VITE_PRE_AUTH_MAINTENANCE_TITLE_EN / _FR
 * - VITE_PRE_AUTH_MAINTENANCE_SUBTITLE_EN / _FR
 *
 * Falls back to _EN variables if _FR not set, then to i18n translations.
 */
export const MaintenanceRoute = () => {
  const { language } = useI18nContext();
  const { title, subtitle } = getMaintenanceMessages(language);

  return <Maintenance title={title} subtitle={subtitle} />;
};
